import { apiRoutes } from './apiRoutes.js';
import { authenticatedFetch } from './auth/authSession.js';

export async function uploadCodelyFile(file, { signal } = {}) {
  const formData = new FormData();
  formData.append('file', file, file.name || 'codely-file');

  const response = await authenticatedFetch(apiRoutes.codelyFiles(), {
    method: 'POST',
    body: formData,
    signal,
  });

  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : null;

  if (!response.ok) {
    throw new Error(
      payload?.message ||
        payload?.errorMessage ||
        payload?.error ||
        `Codely file upload failed with status ${response.status}`
    );
  }

  return payload;
}

export function createJsonFile(content, fileName) {
  return new File([content], fileName, { type: 'application/json' });
}

export function exportFileName(page) {
  const stem = String(page || 'codely-activity')
    .replace(/\.html$/i, '')
    .replace(/[^a-z0-9_-]+/gi, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();
  return `${stem || 'codely-activity'}-export.json`;
}
